import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/features/store';

import filtersItemsSelector from './items';

const filterItemByKeySelector = createSelector(
  [
    filtersItemsSelector,
    (_: RootState, { filterKey }: { filterKey: string }) => filterKey,
  ],
  (filterItems, filterKey) => {
    const filterItem = filterItems.find(item => item.key === filterKey);
    return filterItem;
  },
);

export default filterItemByKeySelector;
